<template>
  <span v-if="!edit" class="text-sm">
    {{value || 'Sem resposta'}}
  </span>

  <RadioAnswer v-else v-bind="$attrs" class="w-full" no-label :question="original"/>
</template>

<script>

import RadioAnswer from '#views/questionnaire/answers/RadioAnswer';

export default {
  name: "RadioDetail",
  inheritAttrs: false,
  components: {
    RadioAnswer
  },
  props: {
    original: {
      type: Object,
      required: true,
    },
    value: {
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
  },
  mounted(){
    this.$emit("update:modelValue", this.value);
  }
};
</script>
